<div class="settings-card">
    <div class="settings-card__header">
        <img src="/assets/images/Group 9.svg" alt="" />
        <div class="settings-card__header-headline">
            <h2>Bine ați venit!</h2>
            <h4>
                Listă cereri
            </h4>
        </div>
    </div>
</div>
<div class="requests-page">
    <div class="content-box ">
        <div class="row">
            <div class="col-sm-12">
                <div class="section">
                    <div class="section-top">
                        <h3 class="section-title">Listă cereri</h3>
                        <div class="section-top-actions">
                            <button type="button" class="btn btn-sm btn-info pull-right ms-1"
                                (click)="rerenderDT(false)">
                                <i class="fa-solid fa-arrows-rotate"></i>
                            </button>
                            <button *ngIf="permissionsService.hasPermission('deps-module.cerere.add')" type="button"
                                class="btn btn-sm btn-primary pull-right ms-1" (click)="openAddDialog()">
                                <i class="fa-solid fa-plus"></i>
                                Adaugă
                            </button>
                            <!-- <button type="button" class="btn btn-sm btn-primary pull-right ms-1"
                                    (click)="downloadManual()">
                                    <img src="assets/icons/icon-download.svg" alt="Descarcă" /> &nbsp;Documentație
                                </button> -->
                        </div>
                    </div>
                    <div class="card-container request-filter p-2" *ngIf="showCard">

                        <form [formGroup]="searchParamsForm" (ngSubmit)="applyFilters()">
                            <div class="row">
                                <div class="col-md-6">
                                    <mat-form-field class="w-100">
                                        <mat-label>Categorie Cerere</mat-label>
                                        <mat-select formControlName="id_category"
                                            (selectionChange)="onCompartimenteChange($event.value)">
                                            <mat-option *ngFor="let row of compartimente" [value]="row.id">
                                                {{ row.name }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div class="col-md-6">
                                    <mat-form-field class="w-100">
                                        <mat-label>Tip problemă</mat-label>
                                        <mat-select formControlName="id_cerere_type">
                                            <mat-option *ngFor="let row of requestTypes$ | async" [value]="row.id">
                                                {{ row.name }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="row ">
                                <div class="col-md-6">
                                    <mat-form-field class="w-100">
                                        <mat-label>Număr cerere</mat-label>
                                        <input matInput type="number" formControlName="id_cerere" />
                                    </mat-form-field>
                                </div>
                                <div class="col-md-6">
                                    <mat-form-field class="w-100">
                                        <mat-label>Cetățean</mat-label>
                                        <input matInput type="text" formControlName="nume_cetatean" />
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <mat-form-field class="w-100">
                                        <mat-label>CNP/CUI</mat-label>
                                        <input matInput type="number" formControlName="cnp_cetatean" />
                                    </mat-form-field>
                                </div>

                                <div class="col-md-6">
                                    <mat-form-field class="w-100">
                                        <mat-label>Email</mat-label>
                                        <input matInput type="text" formControlName="email_cetatean" />
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <mat-form-field class="w-100">
                                        <mat-label>Status Cerere</mat-label>
                                        <mat-select formControlName="validated">
                                            <mat-option *ngFor="let row of validationParameters" [value]="row.id">
                                                {{ row.name }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>

                                <div class="col-md-6">
                                    <mat-form-field class="w-100">
                                        <mat-label>Responsabil</mat-label>
                                        <mat-select formControlName="responsible_id">
                                            <mat-option [value]="-1">
                                                Toți
                                            </mat-option>
                                            <mat-option *ngFor="let row of operatori$ | async" [value]="row.id">
                                                {{ row.name }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <mat-form-field class="w-100">
                                        <mat-label>Locație</mat-label>
                                        <mat-select formControlName="id_locatie">
                                            <mat-option *ngFor="let row of locatii" [value]="row.id">
                                                {{ row.name }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col d-flex justify-content-start">
                                    <button (click)="toggleCard()" type="button"
                                        class="btn btn-sm btn-warning closeBtn">
                                        Închide
                                    </button>
                                </div>
                                <div class="col buttons-submit">
                                    <button (click)="resetForm()" type="button" class="btn btn-sm btn-secondary">
                                        Resetează
                                    </button>
                                    <button type="submit" class="btn btn-sm btn-primary ms-2">
                                        Aplică
                                    </button>
                                </div>
                            </div>
                        </form>
                        <div class="section-spinner position-absolute" *ngIf="isFilterLoading">
                            <div class="spinner position-absolute top-50 start-50 translate-middle">
                                <mat-spinner></mat-spinner>
                                <h3 class="mt-2">
                                    {{ helper.dialogConfig.generalMessages.pleaseWait }}
                                </h3>
                            </div>
                        </div>
                    </div>
                    <div class="row d-flex p-2">
                        <div class="col d-flex justify-content-start align-items-center">
                            <button class="action-button" (click)="toggleCard()" [class.active]="showCard">
                                <img src="assets/images/filter-icon.png" alt="Filtrare" />
                                <span>Filtre</span>
                            </button>
                        </div>
                        <div class="col d-flex justify-content-end">
                            <!-- <mat-chip-listbox *ngIf="notificationParameter.name" aria-label="Notification selection">
                                <mat-chip-option>
                                    <div class="d-flex justify-content-center align-items-center">
                                        <span class="chip-title">
                                            {{notificationParameter.name}}
                                        </span>
                                        <span style="margin-left: 3px;" (click)="removeChip()" aria-label="Remove">
                                            <mat-icon>cancel</mat-icon>
                                        </span>
                                    </div>
                                </mat-chip-option>
                            </mat-chip-listbox> -->
                            <button type="button" class="btn btn-light action-button" [popover]="popTemplate"
                                [adaptivePosition]="true" container="body" boundariesElement="viewport"
                                placement="left">
                                <img src="assets/icons/calendar-icon.svg" alt="Calendar" />
                                <span>{{ selectedStartDate | date : "dd.MM.yyyy" }} - {{ selectedEndDate | date :
                                    "dd.MM.yyyy"
                                    }}
                                </span>
                            </button>

                            <!-- Popover Template below-->
                            <ng-template #popTemplate>
                                <div class="popover">
                                    <div class="row">
                                        <div class="col d-flex justify-content-between">
                                            <h2>Selectați intervalul</h2>
                                            <button style="height: 40px; width: 100px" class="btn btn-light close-btn"
                                                (click)="closePopover()">
                                                <img src="assets/icons/close.svg" alt="Închide"
                                                    style="height: 20px; width: 20px" />
                                                <span class="close-text">ÎNCHIDE</span>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col">
                                            <h3>Filtrare după</h3>
                                            <select [(ngModel)]="dateFilterOption" (change)="onDateFilterChange()">
                                                <option *ngFor="let option of dateFilteringOptions" [value]="option.id">
                                                    {{ option.value }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="row mt-2 mb-2">
                                        <div class="col d-flex justify-content-between">
                                            <button type="button" class="action-button" [class.selected]="
                                                selectedFilteringButton === 'today'
                                                " (click)="setToday()">
                                                <span>ZIUA CURENTĂ</span>
                                            </button>
                                            <!-- <button type="button" class="action-button" [class.selected]="
                                                selectedFilteringButton === 'last_7_days'
                                                " (click)="setLastXDays(7)">
                                                <span>ULTIMELE 7 ZILE</span>
                                            </button>
                                            <button type="button" class="action-button" [class.selected]="
                                                selectedFilteringButton === 'last_30_days'
                                                " (click)="setLastXDays(30)">
                                                <span>ULTIMELE 30 ZILE</span>
                                            </button> -->
                                            <button type="button" class="action-button" [class.selected]="
                                                selectedFilteringButton === 'next_7_days'
                                                " (click)="setNextXDays(7)">
                                                <span>URMĂTOARELE 7 ZILE</span>
                                            </button>
                                            <button type="button" class="action-button" [class.selected]="
                                                selectedFilteringButton === 'next_30_days'
                                                " (click)="setNextXDays(30)">
                                                <span>URMĂTOARELE 30 ZILE</span>
                                            </button>
                                            <button type="button" class="action-button" [class.selected]="
                                                selectedFilteringButton === 'today_to_end_year'
                                                " (click)="setTodayToEndYear()">
                                                <span>ANUL CURENT</span>
                                            </button>
                                            <!-- <button type="button" class="action-button" [class.selected]="
                                                selectedFilteringButton === 'current_year'
                                                " (click)="setYear(0)">
                                                <span>AN CURENT</span>
                                            </button>
                                            <button type="button" class="action-button" [class.selected]="
                                                selectedFilteringButton === 'previous_year'
                                                " (click)="setYear(1)">
                                                <span>AN ANTERIOR</span>
                                            </button> -->
                                        </div>
                                    </div>
                                    <div class="datepicker-container">
                                        <div class="col">
                                            <div class="datepicker-header">
                                                <div class="text">DE LA:</div>
                                                <div class="date">
                                                    {{ selectedStartDate | date : "mediumDate" }}
                                                </div>
                                            </div>
                                            <mat-card>
                                                <mat-calendar #startCalendar [startAt]="selectedStartDate"
                                                    [(selected)]="selectedStartDate" [maxDate]="today"
                                                    [maxDate]="selectedEndDate"
                                                    (selectedChange)="rerenderDT()"></mat-calendar>
                                            </mat-card>
                                        </div>
                                        <div class="col">
                                            <div class="datepicker-header">
                                                <div class="text">PANA LA:</div>
                                                <div class="date">
                                                    {{ selectedEndDate | date : "mediumDate" }}
                                                </div>
                                            </div>
                                            <mat-card>
                                                <mat-calendar #endCalendar [(selected)]="selectedEndDate"
                                                    [maxDate]="lastDayOfNextYear"
                                                    (selectedChange)="rerenderDT()"></mat-calendar>
                                            </mat-card>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                        </div>
                    </div>
                    <div class="request-filter-container">
                        <div class="request-filter">
                            <mat-button-toggle-group name="fontStyle" aria-label="Font Style"
                                (change)="onStatusChange($event)" [value]="selectedStatusID">
                                <mat-button-toggle *ngFor="let status of statusuriCerere" [value]="status.id">
                                    {{ status.name }}
                                </mat-button-toggle>
                            </mat-button-toggle-group>
                        </div>

                        <div class="request-filter">
                            <mat-button-toggle-group name="fontStyle" aria-label="Font Style"
                                (change)="onCategoryChange($event)" [value]="selectedCategory">
                                <mat-button-toggle *ngFor="let option of categoryToggleOptions" [value]="option.id">
                                    {{ option.value}}
                                </mat-button-toggle>
                            </mat-button-toggle-group>
                        </div>
                    </div>

                    <div class="table-container">
                        <table id="datatable" class="row-border hover custom-dt w-100" datatable [dtOptions]="dtOptions"
                            [dtTrigger]="dtTrigger"></table>
                    </div>
                    <div class="section-spinner position-absolute" *ngIf="isLoading">
                        <div class="spinner position-absolute top-50 start-50 translate-middle">
                            <mat-spinner></mat-spinner>
                            <h3 class="mt-2">
                                {{ helper.dialogConfig.generalMessages.pleaseWait }}
                            </h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>